import $api from "@/api";

export async function getPartnerOpeningInfo(spotId: number | string) {
  return $api.get(`/partner/${spotId}/opening-info`);
}
